import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const OtherIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "OtherIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M8.85986 12C8.85986 12.8284 8.18829 13.5 7.35986 13.5C6.53144 13.5 5.85986 12.8284 5.85986 12C5.85986 11.1716 6.53144 10.5 7.35986 10.5C8.18829 10.5 8.85986 11.1716 8.85986 12Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.8599 12C13.8599 12.8284 13.1883 13.5 12.3599 13.5C11.5314 13.5 10.8599 12.8284 10.8599 12C10.8599 11.1716 11.5314 10.5 12.3599 10.5C13.1883 10.5 13.8599 11.1716 13.8599 12Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.8599 12C18.8599 12.8284 18.1883 13.5 17.3599 13.5C16.5314 13.5 15.8599 12.8284 15.8599 12C15.8599 11.1716 16.5314 10.5 17.3599 10.5C18.1883 10.5 18.8599 11.1716 18.8599 12Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3599 12C22.3599 17.5228 17.8827 22 12.3599 22C6.83702 22 2.35986 17.5228 2.35986 12C2.35986 6.47715 6.83702 2 12.3599 2C17.8827 2 22.3599 6.47715 22.3599 12ZM21.1599 12C21.1599 16.8601 17.22 20.8 12.3599 20.8C7.49976 20.8 3.55986 16.8601 3.55986 12C3.55986 7.13989 7.49976 3.2 12.3599 3.2C17.22 3.2 21.1599 7.13989 21.1599 12Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default OtherIcon;
